import { createContext, useContext } from 'react';

type ScrollCarouselDotContextType = {
    isActive: boolean;
    setActive: () => void;
    activeSlide: number;
};

const ScrollCarouselDotContext = createContext<ScrollCarouselDotContextType | null>(null);

export const useScrollCarouselDot = (): ScrollCarouselDotContextType => {
    const context = useContext(ScrollCarouselDotContext);
    if (!context) {
        throw new Error('useScrollCarouselDot must be used within a ScrollCarouselDotProvider');
    }
    return context;
};

export const ScrollCarouselDotProvider = ScrollCarouselDotContext.Provider;
